import { useLDFlagValue } from 'common/useLDFlagValue';
import { isLeadClinician } from 'user';

const displayLink = (user, __, featureToggles) => {
  const flagValue  = useLDFlagValue('release-cqm-store-export');
  const isCQMEnabled = flagValue === undefined || flagValue === true;
  return isLeadClinician(user) && isCQMEnabled;
};

export const ENTRY_LINK = {
  path: '/cqm-dashboard',
  text: 'CQM',
  module: 'cqm-dashboard',
  component: 'Dashboard',
  permission: 'create',
  displayLink: displayLink,
};
